import { LOAD_MODAL_CONTAINER, CLOSE_MODAL_CONTAINER, RESET_MODAL_TOPIC } from '../constants/ActionTypes';


function loadModalContainer(channel) {
  return dispatch =>
    dispatch({
      type: LOAD_MODAL_CONTAINER,
      payload: channel,
    });
}
function closeModalContainer() {
  return dispatch =>
    dispatch({
      type: CLOSE_MODAL_CONTAINER,
    });
}

function resetModalTopic() {
  return dispatch =>
    dispatch({
      type: RESET_MODAL_TOPIC,
    });
}

module.exports = {
  loadModalContainer,
  closeModalContainer,
  resetModalTopic,
};
